import MuiTextField from "@material-ui/core/TextField";
import { fieldToTextField, TextFieldProps } from "formik-material-ui";
import React from "react";

function GameAdminTicketIdField(
  props: TextFieldProps & { customSubmitFn: Function }
) {
  const {
    form: { setFieldValue },
    field: { name },
  } = props;
  const { customSubmitFn, ...other } = props;
  const onChange = React.useCallback(
    async (event) => {
      const { value } = event.target;

      if (value.length > 4) {
        return;
      }

      await setFieldValue(name, value);

      if (value.length >= 4 && customSubmitFn != null) {
        customSubmitFn();
      }
    },
    [setFieldValue, name, customSubmitFn]
  );
  return <MuiTextField {...fieldToTextField(other)} onChange={onChange} />;
}

export default GameAdminTicketIdField;
